import "./WhatsappButton.css";

export default function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/9954129808"  // change number
      className="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
    >
      <i className="fab fa-whatsapp"></i>
    </a>
  );
}
